import { WebchatClientState } from '@botpress/webchat'
import cookie from 'js-cookie'
export const SUPPORT_BOT_CLIENT_ID = '3acb66c7-9afe-4643-b58d-3522ed11d72a' // If you change this make sure to also change it in the studio !!

const getCurrentWebchatState = (clientId: string): WebchatClientState | null => {
  try {
    const text = localStorage.getItem(`bp-webchat-${clientId}`)
    if (!text) {
      return null
    }
    return JSON.parse(text) as WebchatClientState
  } catch (err) {
    console.warn('Could not get webchat state from local storage')
  }

  return null
}

export const initSupportWebchat = (workspaceId: string) => {
  const cookieKey = `bp-webchat-state-${workspaceId}`
  if (window.botpress) {
    const savedWebchatState = cookie.get(cookieKey)
    if (savedWebchatState) {
      localStorage.setItem(`bp-webchat-${SUPPORT_BOT_CLIENT_ID}`, savedWebchatState)
    }

    window.botpress.on('conversation', () => {
      const currentWebchatState = getCurrentWebchatState(SUPPORT_BOT_CLIENT_ID)

      cookie.set(cookieKey, JSON.stringify(currentWebchatState), {
        domain: location.hostname.endsWith('botpress.cloud') ? 'botpress.cloud' : location.hostname,
        expires: 30,
      })
    })

    window.botpress.init({
      botId: '25d6fc2e-6603-4df9-bf53-dd1e324b4fac',
      configuration: {
        version: 'v2',
        composerPlaceholder: 'We typically reply within a day.',
        botName: 'Help Desk',
        botAvatar: 'https://files.bpcontent.cloud/2025/09/04/17/20250904173912-R4IJO1FR.svg',
        botDescription: 'For all of your bot-building queries.',
        website: {},
        email: {},
        phone: {},
        termsOfService: {},
        privacyPolicy: {},
        color: '#3276EA',
        variant: 'solid',
        headerVariant: 'glass',
        themeMode: 'light',
        fontFamily: 'Inter',
        radius: 4,
        feedbackEnabled: false,
        footer: '[⚡ by Botpress](https://botpress.com/?from=webchat)',
        allowFileUpload: true,
        soundEnabled: false,
        toggleChatId: 'bp-toggle-chat',
        proactiveMessageEnabled: false,
        proactiveBubbleMessage: 'Hi! 👋 Need help?',
        proactiveBubbleTriggerType: 'afterDelay',
        proactiveBubbleDelayTime: 10,
      },
      clientId: SUPPORT_BOT_CLIENT_ID,
    })
  }
}
